module.exports = __webpack_public_path__ + "documents/Home+_Terms&Conditions_TOS_0609.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/Home+_Terms&Conditions_TOS_0609.pdf
// module id = 3525
// module chunks = 0